import checkIsValidEmail from 'utils/checkIsValidEmail';
import normalizeEmail from 'utils/normalizeEmail';

const getInvalidEmails = (beneficiariesData: any): any => {
  const result = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const data of beneficiariesData) {
    const email = data['EMAIL'] || '-';
    const normalizedEmail = normalizeEmail(email);

    const validEmial = checkIsValidEmail(normalizedEmail);
    if (!validEmial) {
      result.push(normalizedEmail);
    }
  }
  return result;
};

export default getInvalidEmails;
